import { z } from 'zod';

export const inventoryMergeFields = [
  'name',
  'sku',
  'category',
  'condition',
  'retailPrice',
  'minimumPrice',
  'description',
  'upc',
  'manufacturerPartNumber',
  'color',
  'taxable',
] as const;

export const mergeInventoryItemsSchema = z.object({
  primaryId: z.string().uuid(),
  duplicateIds: z.array(z.string().uuid()).min(1).max(50),
  fieldSelections: z.record(z.string().uuid()).default({}),
  supplierSkuHandling: z.enum(['keep_all', 'manual']).default('keep_all'),
  supplierSkuAssignments: z
    .array(
      z.object({
        itemId: z.string().uuid().optional(),
        supplierId: z.string().uuid(),
        supplierSku: z.string().max(150).optional(),
        costPrice: z.number().nonnegative().optional(),
        isPreferred: z.boolean().optional(),
      }),
    )
    .default([]),
  reason: z.string().trim().min(1).max(2000),
  managerOverrideAuthorizedBy: z.string().uuid(),
  acknowledgeGradeWarning: z.boolean().optional(),
  acknowledgeConditionMismatch: z.boolean().optional(),
});

export const previewInventoryMergeSchema = mergeInventoryItemsSchema
  .omit({
    reason: true,
    managerOverrideAuthorizedBy: true,
    acknowledgeGradeWarning: true,
    acknowledgeConditionMismatch: true,
  })
  .extend({
    reason: z.string().optional(),
  });

export type MergeInventoryItemsInput = z.infer<typeof mergeInventoryItemsSchema>;
